import React from "react";
import { Card } from "react-bootstrap";
import { Doughnut } from "react-chartjs-2";

const CpuHealth = ({ health }) => {
  const load = health?.systemLoad ?? 0;
  const cores = health?.availableProcessors ?? 1;

  const loadPercent = Math.min(Math.max((load / cores) * 100, 0), 100);
  const idlePercent = 100 - loadPercent;

  const data = {
    labels: ["Load %", "Idle %"],
    datasets: [
      {
        data: [loadPercent, idlePercent],
        backgroundColor: ["#FF9F40", "#E0E0E0"],
      },
    ],
  };

  const options = {
    cutoutPercentage: 70, // v2 syntax, not "cutout"
    legend: { position: "bottom" },
    tooltips: {
      callbacks: {
        label: function (tooltipItem, chartData) {
          const dataset = chartData.datasets[tooltipItem.datasetIndex];
          const value = dataset.data[tooltipItem.index];
          return `${chartData.labels[tooltipItem.index]}: ${value.toFixed(2)}%`;
        },
      },
    },
  };

  return (
    <Card className="flex-fill w-100">
      <Card.Header>
        <Card.Title>CPU</Card.Title>
      </Card.Header>
      <Card.Body className="d-flex justify-content-center align-items-center flex-column">
        <div style={{ width: "200px" }}>
          <Doughnut data={data} options={options} />
        </div>
        <div className="mt-3 text-center">
          <h5>{loadPercent.toFixed(1)}%</h5>
          <small>
            Load Avg: {load.toFixed(2)} | Cores: {cores}
          </small>
        </div>
      </Card.Body>
      <Card.Footer>
        <small className="d-flex">
          Status:{" "}
          <div
            className={`ms-2 me-2 circle ${
              health.status === "UP"
                ? "pulse green"
                : health.status === "DOWN"
                ? "red"
                : health.status === "WARN"
                ? "yellow"
                : "blue"
            }`}
          ></div>
        </small>
      </Card.Footer>
    </Card>
  );
};

export default CpuHealth;
